export const subscriptionPlansSelector = (state) => {
  return state.subscriptions.subscriptionPlans;
};
